import React from 'react'
import '../../css/pages/loginPage/LoadingAnimation.css'
import '../../css/animations.css'

import keyImg from '../../images/loadingKey.png'

function LoadingAnimation() {
    return (
      <img className='loadingKey' src={keyImg} alt='a sillouhette of a key' />  
    )
}

export default LoadingAnimation